export default "__VITE_ASSET__BdM$pgLx__"